define([
    "jquery",
    "underscore",
    "marionette",
    "views/common/chartjs_view",
    "views/common/chartjs_utils",
    "views/common/chartjs_options",
], function ($, _, Marionette, ChartView, chartUtils, chartOptions) {
    return Marionette.LayoutView.extend({
        el: "#content_layout",

        ui: {
            "filters": ".filter",
            "filterBtn": "#filter_btn",
            "mt4AccountNo": "#mt4_account_no",
        },

        events: {
            "change @ui.mt4AccountNo": function () {
                window.location = "/account/trading_analytics/" + this.ui.mt4AccountNo.val();
            },
        },

        regions: {
            "chart": "#chart",
        },

        initialize: function () {
            this.account_no = window.account_no || null;

            var that = this;
            this.bindUIElements();

            this.chartView = new ChartView({
                pagination: {
                    navigation: false,
                },
                chartType: 'pie',
                chartOptions: chartOptions.pieChartOptions,
                chartPlugins: [chartUtils.PieLabels, chartUtils.PieLegend],
                ajax: {
                    url: "/rest_account/trader_status_individual_chart",
                    method: "POST",
                    prepareData: function () {
                        var data = [];
                        data["account_no"] = that.account_no;

                        return data;
                    },
                    parseChartData: function ({data}) {
                        const sortedData = [...data].sort((a, b) => (-a.value + +b.value));
                        return {
                            labels: sortedData.map((el) => el.name),
                            datasets: [
                                {
                                    ...chartOptions.pieChartDatasetOptions,
                                    label: "Pie",
                                    data: sortedData.map((el) => el.value),
                                    borderColor: "#f4f4f4",
                                },
                            ],
                        };
                    },
                },
            });
            this.showChildView("chart", this.chartView);
        },
    });
});